import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from "dompurify";
const SanitisedImage = (props) => {
    return (_jsx("img", { src: DOMPurify.sanitize(props.src), alt: props.alt, className: props.className, width: props.width, height: props.height }));
};
export default SanitisedImage;
